export default async function currentWorkplace() {
  const currentWorkplaceResponse = await Workplace.current()
  // The command's `current` collection is already deserialized into an array of
  // models by the api-maker Deserializer, so take the first element directly.
  const currentWorkplace = digg(currentWorkplaceResponse, "current", 0)

  return currentWorkplace
}
